import React from 'react';
import "./Dashboard.css";
import AppSelector from "./AppSelector.mjs";
import MailApp from "./Mail/MailApp.mjs";
import Templatebox from "./Mail/Templatebox.mjs";
import MessagesApp from "./Messages/MessagesApp.mjs";
import AvvisiApp from "./Avvisi/AvvisiApp.mjs";

const G = window.glob;

const Dashboard = class extends React.Component {
	constructor(props) {
		super(props);
		const ps = G.getStatus('PlayerStatus');
		this.state = {
			simulationApp: ps?.simulationApp ?? "email",
			dashboard: ps?.dashboard ?? {},
			gamechosen: G.getStatus('GameChosen'),
			lang: G.getStatus('Language'),
			toptab: G.getCurrentPageParam('tab'),
			appHasAnnunci: G.getStatus('appHasAnnunci')
		};
		this.uid = G.generateUid('Dashboard');
	}
	componentDidMount() {
		G.register('mainOperation', (m)=>{
			const t = m?.params?.tab;
			if ( this.state.toptab !== t ) this.setState({toptab: t });
		}, this.uid);
		G.register('PlayerStatus', s =>{
			const ns = {};
			if ( s.simulationApp && s.simulationApp !== this.state.simulationApp )
				ns.simulationApp = s.simulationApp;
			if ( s.dashboard ) ns.dashboard = s.dashboard;
			if (Object.keys(ns).length) this.setState(ns);
		}, this.uid);
		G.register('GameChosen', g =>{
			this.setState({GameChosen: g});
		}, this.uid);
		G.register('Language', l =>{
			this.setState({lang: l});
		}, this.uid);
		G.register('appHasAnnunci', a =>{
			if ( a !== this.state.appHasAnnunci ) this.setState({appHasAnnunci: a});
		}, this.uid)
	}
	componentWillUnmount() {
		G.deregister( this.uid );
	}

	render() {
		let sa = this.state.simulationApp;
		const templates = G.getStatus('Player')?.admin?.gameMaster ? G.getStatus('Copione')?.template : false;
		if ( ! templates && sa === 'templates' ) sa='email';
		//if ( this.state.toptab !== 'Dashboard' ) return "";
		return(
			<div className={"Dashboard"} id={this.uid}>
				<h1 key={this.state.lang}>
					{this.state.gamechosen?.name || G.label('Game')}
				</h1>
				<div className={"AppSelectorContainer"}>
					<AppSelector simulationApp={sa} templates={templates}/>
				</div>
				<div
					className={"AppContainer"}
					hidden={sa !== 'email'}
				>
					<MailApp/>
				</div>
				<div
					className={"AppContainer"}
					hidden={sa !== 'messages'}
				>
					<MessagesApp />
				</div>
				{templates && (sa === 'templates') && (
					<div className={"AppContainer"}>
						<Templatebox data={templates}/>
					</div>
				)}
				{ this.state.appHasAnnunci && (sa === 'avvisi') && (
					<div className={"AppContainer"}>
						<AvvisiApp/>
					</div>
				)}
			</div>
		)
	}
};

export default Dashboard;